"use strict";
exports.__esModule = true;
exports.LogosUrlEnum = void 0;
/**
 *
 */
var LogosUrlEnum;
(function (LogosUrlEnum) {
    LogosUrlEnum["KUSHKI_LOGO"] = "https://kushki-static-dev.s3.amazonaws.com/3DS/kushki_logo.svg";
    LogosUrlEnum["ANY_BANK_LOGO"] = "https://kushki-static-dev.s3.amazonaws.com/3DS/any_bank_logo.svg";
    LogosUrlEnum["CARD_NETWORK_LOGO"] = "https://kushki-static-dev.s3.amazonaws.com/3DS/card_network_logo.svg";
})(LogosUrlEnum = exports.LogosUrlEnum || (exports.LogosUrlEnum = {}));
